export const COUNTRY_CODES = {
    "BD": {
        "lat": 24.4768783,
        "lng": 90.2932426
    },
    "WF": {
        "lat": -13.8173323,
        "lng": -177.1489648
    },
    "BF": {
        "lat": 12.0753083,
        "lng": -1.6880313
    },
    "BG": {
        "lat": 42.6073975,
        "lng": 25.4856617
    },
    "BA": {
        "lat": 44.3053476,
        "lng": 17.5961467
    },
    "BB": {
        "lat": 13.1500331,
        "lng": -59.5250304
    },
    "BE": {
        "lat": 50.6407351,
        "lng": 4.66696
    },
    "BL": {
        "lat": 17.8962582,
        "lng": -62.8299255
    },
    "BM": {
        "lat": 32.3018217,
        "lng": -64.7603582
    },
    "BN": {
        "lat": 4.4137155,
        "lng": 114.5653908
    },
    "BO": {
        "lat": -17.0568695,
        "lng": -64.9912285
    },
    "JP": {
        "lat": 36.5748441,
        "lng": 139.2394179
    },
    "BI": {
        "lat": -3.3634356,
        "lng": 29.8870575
    },
    "BJ": {
        "lat": 9.5293472,
        "lng": 2.2584408
    },
    "BT": {
        "lat": 27.549511,
        "lng": 90.5119273
    },
    "JM": {
        "lat": 18.1850507,
        "lng": -77.3947692
    },
    "BV": {
        "lat": -54.4191375,
        "lng": 3.36098251648907
    },
    "JO": {
        "lat": 31.1667049,
        "lng": 36.941628
    },
    "WS": {
        "lat": -13.7693894,
        "lng": -172.1200507
    },
    "BR": {
        "lat": -10.3333332,
        "lng": -53.1999999
    },
    "BS": {
        "lat": 24.7736546,
        "lng": -78.0000546
    },
    "JE": {
        "lat": 49.2214561,
        "lng": -2.1358385
    },
    "BY": {
        "lat": 53.4250605,
        "lng": 27.6971358
    },
    "BZ": {
        "lat": 16.8259793,
        "lng": -88.7600926
    },
    "RU": {
        "lat": 64.6863136,
        "lng": 50.7453061,
        zoom: 3
    },
    "RW": {
        "lat": -1.964663,
        "lng": 30.0644358
    },
    "RS": {
        "lat": 44.1534121,
        "lng": 20.55144
    },
    "TL": {
        "lat": -8.5151978,
        "lng": 125.8375756
    },
    "RE": {
        "lat": -21.1309331,
        "lng": 55.5265771
    },
    "TM": {
        "lat": 39.3763807,
        "lng": 59.3924609
    },
    "TJ": {
        "lat": 38.6281733,
        "lng": 70.8156541
    },
    "RO": {
        "lat": 45.9852129,
        "lng": 24.6859225
    },
    "TK": {
        "lat": -9.1676395,
        "lng": -171.8196877
    },
    "GW": {
        "lat": 12.100035,
        "lng": -14.9000213
    },
    "GU": {
        "lat": 13.4501257,
        "lng": 144.757551029721
    },
    "GT": {
        "lat": 15.6356088,
        "lng": -89.8988086
    },
    "GR": {
        "lat": 38.9953683,
        "lng": 21.9877132
    },
    "GQ": {
        "lat": 1.613172,
        "lng": 10.5170357
    },
    "GP": {
        "lat": 16.2490067,
        "lng": -61.5650443
    },
    "BH": {
        "lat": 26.1551249,
        "lng": 50.5344606
    },
    "GY": {
        "lat": 4.8417097,
        "lng": -58.641689
    },
    "GG": {
        "lat": 49.46229125,
        "lng": -2.58120215032944
    },
    "GF": {
        "lat": 4.0039882,
        "lng": -52.9999979
    },
    "GE": {
        "lat": 41.6809707,
        "lng": 44.0287382
    },
    "GD": {
        "lat": 12.1360374,
        "lng": -61.6904044
    },
    "GB": {
        "lat": 54.7023545,
        "lng": -3.2765752
    },
    "GA": {
        "lat": -0.8999694,
        "lng": 11.6899699
    },
    "GN": {
        "lat": 10.7226226,
        "lng": -10.7083586
    },
    "GM": {
        "lat": 13.470062,
        "lng": -15.4900463
    },
    "GL": {
        "lat": 77.6192349,
        "lng": -42.8125966
    },
    "KW": {
        "lat": 29.2733964,
        "lng": 47.4979476
    },
    "GI": {
        "lat": 36.1451465,
        "lng": -5.3484847
    },
    "GH": {
        "lat": 8.0300284,
        "lng": -1.080027
    },
    "OM": {
        "lat": 21.0000287,
        "lng": 57.0036901
    },
    "TN": {
        "lat": 33.8439408,
        "lng": 9.400138
    },
    "BW": {
        "lat": -23.1681781,
        "lng": 24.5928742
    },
    "HR": {
        "lat": 45.5643442,
        "lng": 17.0118954
    },
    "HT": {
        "lat": 19.1399952,
        "lng": -72.3570971
    },
    "HU": {
        "lat": 47.1817585,
        "lng": 19.5060937
    },
    "HK": {
        "lat": 22.2793278,
        "lng": 114.1628131
    },
    "HN": {
        "lat": 15.0610686,
        "lng": -84.5978533
    },
    "HM": {
        "lat": 50.8298881,
        "lng": -127.513553376673
    },
    "KR": {
        "lat": 35.3985008,
        "lng": 127.937111
    },
    "AD": {
        "lat": 42.5407167,
        "lng": 1.5732033
    },
    "PR": {
        "lat": 18.2017809,
        "lng": -66.5841245
    },
    "PS": {
        "lat": 18.2017809,
        "lng": -66.5841245
    },
    "PW": {
        "lat": 6.097367,
        "lng": 133.313631
    },
    "PT": {
        "lat": 40.033265,
        "lng": -7.8896262
    },
    "KN": {
        "lat": 17.3462278,
        "lng": -62.7687276
    },
    "PY": {
        "lat": -23.3165934,
        "lng": -58.1693444
    },
    "AI": {
        "lat": 18.1954947,
        "lng": -63.0750233
    },
    "PA": {
        "lat": 8.3096067,
        "lng": -81.3066245
    },
    "PF": {
        "lat": -18.6243748,
        "lng": -144.6434897
    },
    "PG": {
        "lat": -5.6816068,
        "lng": 144.2489081
    },
    "PE": {
        "lat": -6.8699696,
        "lng": -75.0458514
    },
    "PK": {
        "lat": 30.3308401,
        "lng": 71.247499
    },
    "PH": {
        "lat": 12.7503486,
        "lng": 122.7312101
    },
    "PN": {
        "lat": -25.0657718,
        "lng": -130.1017822
    },
    "PL": {
        "lat": 52.0977181,
        "lng": 19.0258159,
        zoom: 5,
    },
    "PM": {
        "lat": 46.8374544,
        "lng": -56.2120554
    },
    "ZM": {
        "lat": -14.5186238,
        "lng": 27.5599164
    },
    "EH": {
        "lat": 24.1797324,
        "lng": -13.7667847
    },
    "EE": {
        "lat": 58.7523778,
        "lng": 25.3319078
    },
    "EG": {
        "lat": 26.2540493,
        "lng": 29.2675469
    },
    "ZA": {
        "lat": -28.8166235,
        "lng": 24.991639
    },
    "EC": {
        "lat": -1.3397667,
        "lng": -79.3666964
    },
    "AL": {
        "lat": 41.000028,
        "lng": 19.9999619
    },
    "AO": {
        "lat": -11.8775767,
        "lng": 17.5691241
    },
    "KZ": {
        "lat": 47.2286086,
        "lng": 65.2093197
    },
    "ET": {
        "lat": 10.2116702,
        "lng": 38.6521203
    },
    "ZW": {
        "lat": -18.4554962,
        "lng": 29.7468414
    },
    "KY": {
        "lat": 19.5417212,
        "lng": -80.5667131
    },
    "ES": {
        "lat": 40.0028028,
        "lng": -4.0031039
    },
    "ER": {
        "lat": 15.9500319,
        "lng": 37.9999668
    },
    "ME": {
        "lat": 43.0285558,
        "lng": 19.291739
    },
    "MD": {
        "lat": 47.286747,
        "lng": 28.5110236
    },
    "MG": {
        "lat": -18.9249603,
        "lng": 46.4416422
    },
    "MF": {
        "lat": 18.0814066,
        "lng": -63.046713
    },
    "MA": {
        "lat": 31.1728192,
        "lng": -7.3366042
    },
    "MC": {
        "lat": 43.7311424,
        "lng": 7.4197576
    },
    "UZ": {
        "lat": 41.32373,
        "lng": 63.9528098
    },
    "MM": {
        "lat": 17.1750495,
        "lng": 95.9999652
    },
    "ML": {
        "lat": 16.3700359,
        "lng": -2.2900238
    },
    "MO": {
        "lat": 22.1899448,
        "lng": 113.5380454
    },
    "MN": {
        "lat": 46.8250388,
        "lng": 103.8499736
    },
    "MH": {
        "lat": 6.9518742,
        "lng": 170.9985095
    },
    "MK": {
        "lat": 41.6171214,
        "lng": 21.7168387
    },
    "MU": {
        "lat": -20.275945,
        "lng": 57.5703566
    },
    "MT": {
        "lat": 27.5015719,
        "lng": 85.2451666
    },
    "MW": {
        "lat": -13.2687203,
        "lng": 33.9301963
    },
    "MV": {
        "lat": 4.7064352,
        "lng": 73.3287853
    },
    "MQ": {
        "lat": 14.6113732,
        "lng": -60.9620776
    },
    "MP": {
        "lat": 14.1490205,
        "lng": 145.213452483189
    },
    "MS": {
        "lat": 16.7417041,
        "lng": -62.1916843
    },
    "MR": {
        "lat": 20.2540382,
        "lng": -9.2399262
    },
    "AU": {
        "lat": -24.7761085,
        "lng": 134.755,
        zoom: 4
    },
    "UG": {
        "lat": 1.5333554,
        "lng": 32.2166578
    },
    "MY": {
        "lat": 2.3923759,
        "lng": 112.8471939
    },
    "MX": {
        "lat": 19.4326009,
        "lng": -99.1333415
    },
    "MZ": {
        "lat": -19.3022329,
        "lng": 34.9144977
    },
    "FR": {
        "lat": 46.603354,
        "lng": 1.8883335
    },
    "AW": {
        "lat": 12.5013629,
        "lng": -69.9618474
    },
    "AF": {
        "lat": 33.7680065,
        "lng": 66.2385139
    },
    "AX": {
        "lat": 60.2166218,
        "lng": 19.9438638
    },
    "FI": {
        "lat": 63.2467777,
        "lng": 25.9209164
    },
    "FJ": {
        "lat": -18.1239695,
        "lng": 179.0122737
    },
    "FK": {
        "lat": -51.9666423,
        "lng": -59.5500386
    },
    "FM": {
        "lat": 5.5600565,
        "lng": 150.1982846
    },
    "FO": {
        "lat": 62.19889095,
        "lng": -6.81780730578171
    },
    "NI": {
        "lat": 12.3724928,
        "lng": -84.8700307
    },
    "NL": {
        "lat": 52.2379891,
        "lng": 5.53460738161551
    },
    "NO": {
        "lat": 64.574131,
        "lng": 11.5270102892405
    },
    "NA": {
        "lat": -23.2335498,
        "lng": 17.3231107
    },
    "VU": {
        "lat": -16.5255068,
        "lng": 168.1069154
    },
    "NC": {
        "lat": -21.3019904,
        "lng": 165.4880773
    },
    "NE": {
        "lat": 17.7356214,
        "lng": 9.3238432
    },
    "NF": {
        "lat": -29.02900945,
        "lng": 167.958672246969
    },
    "NG": {
        "lat": 9.6000359,
        "lng": 7.9999721
    },
    "NZ": {
        "lat": -41.500083,
        "lng": 172.8344077
    },
    "NP": {
        "lat": 28.1082107,
        "lng": 84.0917515
    },
    "NR": {
        "lat": -0.5249623,
        "lng": 166.9333009
    },
    "NU": {
        "lat": -19.0536413,
        "lng": -169.861341
    },
    "CK": {
        "lat": -16.049278,
        "lng": -160.355485
    },
    "CI": {
        "lat": 7.9897371,
        "lng": -5.5679457
    },
    "CH": {
        "lat": 46.7985624,
        "lng": 8.2319736
    },
    "CO": {
        "lat": 2.8894434,
        "lng": -73.7838919
    },
    "CN": {
        "lat": 35.000074,
        "lng": 104.999927,
        zoom: 3,
    },
    "CM": {
        "lat": 4.6125522,
        "lng": 13.1535811
    },
    "CL": {
        "lat": -31.7613364,
        "lng": -71.3187696
    },
    "CC": {
        "lat": -12.1691893,
        "lng": 96.8301442
    },
    "CA": {
        "lat": 60.0666922,
        "lng": -100.991707,
        zoom: 3
    },
    "CG": {
        "lat": -2.9814343,
        "lng": 23.8222636
    },
    "CF": {
        "lat": 7.0323598,
        "lng": 19.9981227
    },
    "CD": {
        "lat": -2.9814343,
        "lng": 23.8222636
    },
    "CZ": {
        "lat": 49.8167003,
        "lng": 15.4749544
    },
    "CY": {
        "lat": 34.9823018,
        "lng": 33.1451285
    },
    "CX": {
        "lat": -10.4878278,
        "lng": 105.6329821
    },
    "CR": {
        "lat": 10.2735633,
        "lng": -84.0739101
    },
    "CV": {
        "lat": 16.0000552,
        "lng": -24.0083946
    },
    "CU": {
        "lat": 23.0131338,
        "lng": -80.8328747
    },
    "SZ": {
        "lat": -26.5624805,
        "lng": 31.3991317
    },
    "SY": {
        "lat": 34.6401861,
        "lng": 39.0494106
    },
    "KG": {
        "lat": 41.5089324,
        "lng": 74.724091
    },
    "KE": {
        "lat": 1.4419683,
        "lng": 38.4313975
    },
    "SR": {
        "lat": 4.1413025,
        "lng": -56.0771186
    },
    "KI": {
        "lat": 0.4483283,
        "lng": -171.6645387
    },
    "KH": {
        "lat": 13.5066394,
        "lng": 104.869423
    },
    "SV": {
        "lat": 13.8000382,
        "lng": -88.9140682
    },
    "KM": {
        "lat": -12.2045175,
        "lng": 44.2832964
    },
    "ST": {
        "lat": 0.8875498,
        "lng": 6.9648718
    },
    "SK": {
        "lat": 48.7411522,
        "lng": 19.4528646
    },
    "SJ": {
        "lat": 78.7198519,
        "lng": 20.3493328
    },
    "SI": {
        "lat": 45.8133113,
        "lng": 14.4808369
    },
    "SH": {
        "lat": -15.991955,
        "lng": -5.6999093
    },
    "SO": {
        "lat": 8.3676771,
        "lng": 49.083416
    },
    "SN": {
        "lat": 14.4750607,
        "lng": -14.4529611
    },
    "SM": {
        "lat": 43.9458623,
        "lng": 12.458306
    },
    "SL": {
        "lat": 8.6400349,
        "lng": -11.8400268
    },
    "SC": {
        "lat": -4.6574976,
        "lng": 55.4540146
    },
    "SB": {
        "lat": -9.7354343,
        "lng": 162.8288542
    },
    "SA": {
        "lat": 25.6242618,
        "lng": 42.3528328
    },
    "SG": {
        "lat": 1.2904527,
        "lng": 103.852038
    },
    "SE": {
        "lat": 59.6749712,
        "lng": 14.5208584
    },
    "SD": {
        "lat": 14.5844444,
        "lng": 29.4917691
    },
    "DO": {
        "lat": 19.0974031,
        "lng": -70.3028025
    },
    "DM": {
        "lat": 15.4113138,
        "lng": -61.3653617
    },
    "DJ": {
        "lat": 11.85677545,
        "lng": 42.7577845199437
    },
    "DK": {
        "lat": 55.670249,
        "lng": 10.3333283
    },
    "DE": {
        "lat": 51.0834196,
        "lng": 10.4234469
    },
    "YE": {
        "lat": 16.3471243,
        "lng": 47.8915271
    },
    "AT": {
        "lat": 47.2000338,
        "lng": 13.199959
    },
    "DZ": {
        "lat": 28.0000272,
        "lng": 2.9999825
    },
    "US": {
        "lat": 39.7837304,
        "lng": -100.4458824,
        zoom: 3,
    },
    "UY": {
        "lat": -32.8755547,
        "lng": -56.0201524
    },
    "YT": {
        "lat": -12.8230479,
        "lng": 45.1520755
    },
    "UM": {
        "lat": 28.2417536,
        "lng": -177.3754307
    },
    "LB": {
        "lat": 33.8750629,
        "lng": 35.843409
    },
    "LC": {
        "lat": 13.8250489,
        "lng": -60.9750359
    },
    "LA": {
        "lat": 20.0171109,
        "lng": 103.378253
    },
    "TV": {
        "lat": -7.7689589,
        "lng": 178.1167698
    },
    "TW": {
        "lat": 23.9739374,
        "lng": 120.9820179
    },
    "TT": {
        "lat": 10.8677845,
        "lng": -60.9821066
    },
    "TR": {
        "lat": 38.9597594,
        "lng": 34.9249653
    },
    "LK": {
        "lat": 7.878,
        "lng": 80.7038245875
    },
    "LI": {
        "lat": 47.1416307,
        "lng": 9.5531527
    },
    "LV": {
        "lat": 56.8666904,
        "lng": 24.5999717
    },
    "TO": {
        "lat": -19.9160818,
        "lng": -175.2026423
    },
    "LT": {
        "lat": 55.3500003,
        "lng": 23.7499998
    },
    "LU": {
        "lat": 49.8158683,
        "lng": 6.1296751
    },
    "LR": {
        "lat": 5.7499721,
        "lng": -9.3658523
    },
    "LS": {
        "lat": -29.6039266,
        "lng": 28.3350193
    },
    "TH": {
        "lat": 14.8971921,
        "lng": 100.83273
    },
    "TF": {
        "lat": -44.1511784,
        "lng": 63.8604556
    },
    "TG": {
        "lat": 8.7800265,
        "lng": 1.0199765
    },
    "TD": {
        "lat": 15.6134137,
        "lng": 19.0156172
    },
    "TC": {
        "lat": 21.7214683,
        "lng": -71.6201782
    },
    "LY": {
        "lat": 26.8234472,
        "lng": 18.1236723
    },
    "VA": {
        "lat": 41.902916,
        "lng": 12.453389
    },
    "VC": {
        "lat": 12.90447,
        "lng": -61.2765568
    },
    "AE": {
        "lat": 24.0002488,
        "lng": 53.9994829
    },
    "VE": {
        "lat": 8.0018709,
        "lng": -66.1109317
    },
    "AG": {
        "lat": 17.079128,
        "lng": -61.8222515
    },
    "VG": {
        "lat": 18.4024395,
        "lng": -64.5661641
    },
    "IQ": {
        "lat": 33.0955793,
        "lng": 44.1749775
    },
    "VI": {
        "lat": 18.335765,
        "lng": -64.896335
    },
    "IS": {
        "lat": 64.9841821,
        "lng": -18.1059012
    },
    "IR": {
        "lat": 32.9407496,
        "lng": 52.9471344
    },
    "AM": {
        "lat": 40.7696272,
        "lng": 44.6736646
    },
    "IT": {
        "lat": 42.6384261,
        "lng": 12.674297
    },
    "VN": {
        "lat": 13.2904027,
        "lng": 108.4265113
    },
    "AN": {
        "lat": 12.1546009,
        "lng": -68.9404722492907
    },
    "AQ": {
        "lat": -82.1081821,
        "lng": 34.37824
    },
    "AS": {
        "lat": -14.30063085,
        "lng": -170.695974691655
    },
    "AR": {
        "lat": -34.9964962,
        "lng": -64.9672816
    },
    "IM": {
        "lat": 54.2358167,
        "lng": -4.51459864569825
    },
    "IL": {
        "lat": 30.8760272,
        "lng": 35.0015196
    },
    "IO": {
        "lat": -6.4157191,
        "lng": 72.1173961
    },
    "IN": {
        "lat": 22.3511148,
        "lng": 78.6677428
    },
    "TZ": {
        "lat": -6.5247122,
        "lng": 35.7878438
    },
    "AZ": {
        "lat": 40.3936294,
        "lng": 47.7872508
    },
    "IE": {
        "lat": 52.865196,
        "lng": -7.9794598
    },
    "ID": {
        "lat": -4.7993355,
        "lng": 114.5632032
    },
    "UA": {
        "lat": 49.4871968,
        "lng": 31.2718321
    },
    "QA": {
        "lat": 25.3336984,
        "lng": 51.2295295
    }
};


export const EU_COUNTRY_CODES = [
    "AT", "BE", "BG", "CY", "CZ", "DK", "EE", 
    "FI", "FR", "DE", "GR", "HU", "IE", "IT",
    "LV", "LT", "LU", "MT", "NL", "PL", "PT", 
    "RO", "SK", "SI", "ES", "SE", "GB"
]
